/* eslint-disable jsx-a11y/no-interactive-element-to-noninteractive-role */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import moment from 'utils/moment';
import SectionHeader from '../../../../components/sectionHeader';
import PERMITMODULE from '../../../../icons/PERMITMODULE.png';
import styles from '../Logs/logs.module.scss';
import tableStyles from '../../../../styles/general.module.scss';
import Button from '../../../../components/button';
import {
  getMyApplication, getMyExternalTrainings, getAdpDefaultFields,
  fetchspecificAdpLogs, initiateApplication,
  clearState, clearDetailsState

} from '../../redux/action';
import badgeStyles from '../../../Badging/Detail/detail.module.scss';
import Loading from '../../../../components/loading';
import Modal from '../../../../components/modal';
import Clickable from '../../../../components/clickable/Clickable';
import FormattedMessageWithClass from '../../../../components/formattedMessageWithClass';
import { carryForwardAttachments, filterCustomFieldAnswers, getAttachmentIds } from '../../components/PermitData';


export default function MyApplications({ history }) {
  const dispatch = useDispatch();
  const profile = useSelector(states => states.auth.profile);
  const { id } =profile;
  const [viewDriver, setviewDriver] = useState({ useRecord: '', viewDetails: false });
  const [checkExternalTraining, setCheckExternalTraining] = useState(false);
  const [applicationId, setCurrentApplicationId] = useState('');
  const applications = useSelector(states => states?.permitManagement?.myApplications);
  const actionMyApplications = useSelector(states => states?.permitManagement?.actionMyApplications);
  const actionSaveAsDraft = useSelector(states => states.permitManagement.actionSaveAsDraft);
  const actionSubmitDp = useSelector(states => states.permitManagement.actionSubmitDp);
  const externalTrainingRecords = useSelector(states => states.permitManagement.externalTrainingRecords);
  const actionGetExternalTraining = useSelector(states => states.permitManagement.actionGetExternalTraining);
  const adpDefaultFields = useSelector(states => states.permitManagement.adpDefaultFields);

  // -------------------------------- for renewal the form ----------------------------------------------
  const [renewalFlow, setRenewalFlow] = useState({ init: false, loader: false, appID: null, popup: false, renewal: false });
  const renewalApplication = useSelector(states => states?.permitManagement?.specificLog);
  const adpSchema = useSelector(states => states?.permitManagement?.adpSchema);
  const customFields = useSelector(state => state.permitManagement?.AdpCSchema);
  const oldCustomFields = useSelector(data => data?.permitManagement?.adpCSchema);
  const getAdpDetailStatus = useSelector(states => states.permitManagement.getADPdetailsStatus);
  const adpGetSchemaStatus = useSelector(states => states.permitManagement.adpGetSchemaStatus);
  const adpInitiationStatus = useSelector(states => states.permitManagement.adpInitiationStatus);

  const handelSubmit = async () => {
    const data = {
      application_type: 'Renewal',
      designation: renewalApplication?.designation ? renewalApplication?.designation : '',
      email: renewalApplication?.email ? renewalApplication?.email : '',
      phone: renewalApplication?.phone ? renewalApplication?.phone : '',
      first_name: renewalApplication?.first_name ? renewalApplication.first_name : '',
      last_name: renewalApplication?.last_name ? renewalApplication.last_name : '',
      use_prev_badge: false,
      offline_training: false,
      category_of_adp: renewalApplication?.category_of_adp ? renewalApplication?.category_of_adp : null,
      prev_permit: renewalApplication?.id ? renewalApplication?.id : null,
      prev_badge_no: null
    };
    if (data.phone) {
      data.phone = data.phone[0] + data.phone.slice(1).replace(/[^\d]/g, '');
    }

    if (renewalApplication.initiated_to) {
      data.initiated_to= renewalApplication?.initiated_to?.id;
    }
    // ----------- Forward Attachments to Renewal Application -----------
    const attachmentData = {
      req_attachments: renewalApplication?.req_attachments || {},
      req_attachments_details: renewalApplication?.req_attachments_details || {},
      photo: renewalApplication?.photo
    };
    const newRequiredAttachments = adpSchema?.default_fields?.required_attachements || [];

    const filteredAnswers = await filterCustomFieldAnswers(oldCustomFields, customFields, renewalApplication?.response);
    const filteredResponse = await getAttachmentIds(filteredAnswers);

    const updatedData = await carryForwardAttachments(attachmentData, newRequiredAttachments, renewalApplication);

    data.req_attachments = updatedData.req_attachments;
    data.req_attachments_details = updatedData.req_attachments_details;
    data.attachments = updatedData.attachments;
    data.photo = updatedData.photo;
    data.response = filteredResponse;
    data.signature = [];
    // ----------- Forward Attachments to Renewal Application -----------

    await dispatch(initiateApplication(data));
  };

  useEffect(() => {
    if (renewalFlow.init && renewalFlow.appID) {
      dispatch(fetchspecificAdpLogs(renewalFlow.appID));
      dispatch(getAdpDefaultFields());
      setRenewalFlow(prev => ({ ...prev, renewalFlow: false, appID: null, renewal: true }));
    }
  }, [renewalFlow.init, renewalFlow.appID, dispatch]);

  useEffect(() => {
    if (renewalFlow.renewal && getAdpDetailStatus?.success && adpGetSchemaStatus?.success) {
      setTimeout(() => {
        handelSubmit();
        dispatch(clearDetailsState());
        setRenewalFlow(prev => ({ ...prev, loader: false }));
      }, 500);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAdpDetailStatus, adpGetSchemaStatus, renewalFlow.renewal]);

  useEffect(() => {
    if (adpInitiationStatus?.success) {
      dispatch(clearState());
      dispatch(getMyApplication(id));
    }
  }, [adpInitiationStatus, dispatch, id]);

  const handleSubmitRenewalForm = (ID) => {
    setRenewalFlow({ init: true, loader: true, appID: ID, popup: false });
  };

  const handleRenewalConfirmation = (ID) => {
    setRenewalFlow(prev => ({ ...prev, appID: ID, popup: true }));
  };

  const handleCloseRenewPopup = () => {
    setRenewalFlow({ init: false, loader: false, appID: null, popup: false, renewal: false });
  };

  // -------------------------------- for renewal the form ----------------------------------------------

  const handelApplication = (dId) => {
    if (adpDefaultFields?.enable_external_training) {
      dispatch(getMyExternalTrainings(dId));
      setCurrentApplicationId(dId);
    } else {
      history.push(
        `/adp/myapplications/start/${dId}`
      );
    }
  };

  const trainingInfo = externalTrainingRecords?.permit?.meta_data?.driver_online_elearning_training || {};

  const trainingExpireDate = trainingInfo?.expiry_date && new Date(trainingInfo?.expiry_date);
  const trainingStatus = trainingInfo?.status || '';
  const todayDate = new Date();

  todayDate.setHours(0, 0, 0, 0);
  if (trainingExpireDate) trainingExpireDate.setHours(0, 0, 0, 0);

  let isTrainingExpired = false;
  if (trainingExpireDate < todayDate) {
    isTrainingExpired = true;
  }

  useEffect(() => {
    if (actionGetExternalTraining?.success && applicationId) {
      if (trainingStatus !== 'Completed' || (trainingStatus === 'Completed' && isTrainingExpired)) {
        setCheckExternalTraining(true);
        setCurrentApplicationId('');
      } else {
        history.push(`/adp/myapplications/start/${applicationId}`);
      }
    }
  }, [actionGetExternalTraining, trainingStatus, history, applicationId, isTrainingExpired]);


  useEffect(() => {
    dispatch(getMyApplication(id));
    dispatch(getAdpDefaultFields());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (actionSaveAsDraft.success === true || actionSubmitDp.success === true) {
      dispatch(getMyApplication(id));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionSaveAsDraft, actionSubmitDp]);

  const isRenewalFor90Days = (status, renewal_date) => {
    if (!renewal_date) return false;

    const today = moment().startOf('day'); // normalize to day
    const ninetyDays = moment().add(90, 'days').endOf('day');
    const renewalDate = moment(renewal_date, 'YYYY-MM-DD').startOf('day');

    return (status === 3
        && renewalDate.isSameOrAfter(today)
        && renewalDate.isSameOrBefore(ninetyDays));
  };

  const getLink = (status, renewal_date, rejected_reOpen) => {
    if (status === 11) {
      return (
        <FormattedMessage
          id="inspections.list.table.schedule"
          defaultMessage="Reschedule"
        />
      );
    }
    if (status === 14 && rejected_reOpen) {
      return (
        <button
          className={styles.btn}
          type="button"
        >
          <FormattedMessage
            id="training.start.training"
            defaultMessage="Start"
          />
        </button>
      );
    }
    return (
      <FormattedMessage
        id="inspections.list.table.view"
        defaultMessage="View"
      />
    );
  };


  const getStatus = (ele) => {
    if (ele === 0) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Training Pending</div>;
    } if (ele === 1) {
      return <div style={{ background: '#6DD4001C', color: '#6DD400' }} className={styles.badge}>Pending Applicant Details</div>;
    } if (ele === 2) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Pending Approval</div>;
    } if (ele === 3) {
      return <div style={{ background: '#6DD4001C', color: '#6DD400' }} className={styles.badge}>Approved</div>;
    } if (ele === 4) {
      return <div style={{ background: '#F5515F22', color: '#F5515F' }} className={styles.badge}>Rejected</div>;
    } if (ele === 5) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Expired</div>;
    } if (ele === 6 && adpDefaultFields?.enable_initial_review) {
      return <div style={{ background: '#daeaf8', color: '#3c62a8' }} className={styles.badge}>Pending Review</div>;
    } if (ele === 6 && !adpDefaultFields?.enable_initial_review) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Pending Approval</div>;
    } if (ele === 7) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Cancelled</div>;
    } if (ele === 8) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Suspended</div>;
    } if (ele === 9) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Revoke</div>;
    } if (ele === 10) {
      return <div style={{ background: '#0079C1', color: '#FFFFFF' }} className={styles.badge}>Payment Pending</div>;
    } if (ele === 11) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Pending Scheduling</div>;
    } if (ele === 14) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Draft</div>;
    } if (ele === 15) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Application Withheld</div>;
    } if (ele === 16) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Reschedule Test</div>;
    } if (ele === 17) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Renewed</div>;
    } return null;
  };
  let externalTrainingObj;
  if (adpDefaultFields?.enable_external_training
     && adpDefaultFields?.settings_required_for_public?.external_trainings) {
    externalTrainingObj = JSON.parse(adpDefaultFields?.settings_required_for_public?.external_trainings);
  }

  return (
    <>
    <Loading loadingStatus={actionMyApplications?.loading || actionGetExternalTraining?.loading
      || getAdpDetailStatus?.loading || adpInitiationStatus?.loading || adpGetSchemaStatus?.loading
      || renewalFlow.loader
    } />
      <SectionHeader icon={PERMITMODULE} translationID=" " defaultTitle={'My Applications'} centered />
      <div style={{ display: 'flex' }} className={styles.toolbar}>
        <div className={styles.counter}>
          <FormattedMessage id="adp.list.open" defaultMessage={`Applications (${applications?.count||0})`} />
        </div>

        {profile?.permissions?.airfield_worker_driver_permit?.Initiate &&<Button
        action="primary"
        onClick={() => (history.push('/adp/myapplications/initiate'))}
        translationID="adp.Initieate"
        defaultText="Initiate Application"
      />}
      </div>
      <div style={{ width: '100%', overflowX: 'auto' }}>
     <>
          <table className={tableStyles.table} style={{ margin: 'auto', marginTop: 0, width: '80%' }}>
            <thead>
              <tr>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="First Name" />
                </th>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Company" />
                </th>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Status" />
                </th>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Action" />
                </th>
                <th>
                  {''}
                </th>
              </tr>
            </thead>
            <tbody>
              {applications?.results?.map(ele => (
                <tr>
                  <td style={{ color: 'rgba(50, 51, 102, 1)' }}>{`${ele.first_name} ${ele.last_name}`}</td>
                  <td style={{ color: 'rgba(50, 51, 102, 1)' }}>{ele.company}</td>
                  <td style={{ color: 'rgba(50, 51, 102, 1)' }}>{getStatus(ele?.status)}</td>
                  <td role="presentation">
                    {(() => {
                      const {
                        status,
                        scheduleEnable,
                        calendar_visibility,
                        suspended_details,
                        disable_driver_permit_online_training,
                        retake_training,
                        renewal_date,
                        is_renewed,
                        rejected_reOpen
                      } = ele;

                      const recordId = ele?.id;

                      const viewButtonLink = status === 0
                        || status === 1
                        || (status === 14 && !rejected_reOpen)
                        || (status === 11
                          && scheduleEnable
                          && (calendar_visibility === 'both' || calendar_visibility === 'driver'))
                        || (status === 8
                          && suspended_details?.training_status === 'Pending'
                          && !disable_driver_permit_online_training)
                        || (retake_training && (status === 8 || status === 3));

                      const isRetake = (status === 8 && suspended_details?.training_status === 'Pending')
                        || retake_training;

                      const renewalAllowed = isRenewalFor90Days(status, renewal_date)
                        && !is_renewed
                        && profile?.permissions?.airfield_worker_driver_permit?.Renew;

                      const isRejectedReopen = status === 14 && rejected_reOpen;

                      const detailPath = `/adp/detail/${recordId}`;

                      // --- Render ---
                      if (viewButtonLink) {
                        return (
                          <button
                            className={styles.btn}
                            type="button"
                            onClick={() => handelApplication(recordId)}
                          >
                            {isRetake ? (
                              <FormattedMessage
                                id="adp.list.table.retake.view"
                                defaultMessage="Retake"
                              />
                            ) : (
                              <FormattedMessage
                                id="training.start.training"
                                defaultMessage="Start"
                              />
                            )}
                          </button>
                        );
                      }

                      if (renewalAllowed) {
                        return (
                          <Clickable onClick={() => handleRenewalConfirmation(recordId)}
                            style={{ marginLeft: '14px', cursor: 'pointer', color: '#007bff' }}
                          >
                            <FormattedMessage
                              id="inspections.list.table.renewal"
                              defaultMessage="Renewal"
                            />
                          </Clickable>
                        );
                      }

                      return (
                        <div
                          style={{ marginLeft: !isRejectedReopen && '14px', cursor: 'pointer' }}
                          role="presentation"
                          onClick={() => setviewDriver({
                              ...viewDriver,
                              viewDetails: true,
                              useRecord: ele
                            })
                          }
                        >
                          <Link
                            to={{
                              pathname: isRejectedReopen ? `/adp/detail/${recordId}/reapply` : detailPath,
                              state: { myApplication: true }
                            }}
                          >
                            {getLink(status, renewal_date, rejected_reOpen)}
                          </Link>
                        </div>
                      );
                    })()}
                  </td>

                  <td>
                    {ele.saved_as_draft && (
                      <div style={{
                        width: '49px',
                        borderRadius: '13px',
                        padding: '5px 8px',
                        background: '#E6EAEE',
                        color: '#8C9EA7'
                      }}
                      >
                        <FormattedMessage
                          id="inspections.step0.draft"
                          defaultMessage="Draft"
                        />
                      </div>)
                        }
                  </td>
                </tr>))}
            </tbody>
          </table>
     </>
      {checkExternalTraining && (
        <Modal
          showIn={checkExternalTraining}
          onClose={() => setCheckExternalTraining(prev => !prev)}
          width="500px"
          minHeight="24%"
          centered
        >
          <div className={badgeStyles.newTask}>
            <div className={badgeStyles.closeicon} style={{ padding: '15px 15px 0px 15px' }}>
              <FormattedMessage
                tagName="p"
                id="adp.log.suspend.application"
                defaultMessage={'Start Application'}
              />
              <Clickable onClick={() => setCheckExternalTraining(prev => !prev)}>
                <div style={{ cursor: 'pointer' }}>X</div>
              </Clickable>
            </div>
            <div className={styles.subHeading} style={{ fontWeight: '500' }}>
              <FormattedMessage
                tagName="p"
                id="adp.log.reactivate.warning.message.approved"
                defaultMessage="Driver Online E-learning has not been completed or has expired.
                Please complete your training before starting the application process."
              />
              {externalTrainingObj?.training_urls?.driver_online_elearning_training_url && (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a href={externalTrainingObj?.training_urls?.driver_online_elearning_training_url}
                target="_blank" rel="noopener noreferrer"> Click here to proceed
                </a>
              )}
            </div>
          </div>
        </Modal>
      )}
      <Modal
        showIn={renewalFlow.popup} onClose={() => handleCloseRenewPopup()}
        width="400px" minHeight="100px" disableOutsideClick closeIcon
        title="Confirmation" titleId="lease.tenants.steps.step5.confirmation"
        btnList={[
          { id: 'forms.darft.no', label: 'No', action: 'tertiary', onClick: () => handleCloseRenewPopup() },
          { id: 'forms.darft.yes', label: 'Yes', action: 'secondary', onClick: () => handleSubmitRenewalForm(renewalFlow.appID) }
        ]}
      >
        <div style={{ padding: '15px 30px' }}>
          <FormattedMessageWithClass
            tagName="h5"
            id="renewal.confirmation.permit"
            defaultMessage="Are you sure you want to renew this Permit?"
          />
        </div>
      </Modal>

      </div>
    </>
  );
}
